/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { TFunction } from 'react-i18next';
import { makeNullableNumberField } from './nullable-number-field';

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'name',
    label: translate('common.labels.name'),
    rules: requiredRule(translate)
  },
  {
    type: 'inputNumberField',
    name: 'campaignCostPerDay',
    label: translate('common.labels.campaignCostPerDay'),
    rules: undefined,
    formatter: (value: any) => String(value ?? ''),
    parser: (value: any) => value
  },
  {
    type: 'render',
    name: 'maxConcurrentCampaigns',
    renderComponent: makeNullableNumberField(
      'maxConcurrentCampaigns',
      translate('common.labels.maxConcurrentCampaigns'),
      translate
    )
  },
  {
    type: 'render',
    name: 'maxCampaignsPerMonth',
    renderComponent: makeNullableNumberField(
      'maxCampaignsPerMonth',
      translate('common.labels.maxCampaignsPerMonth'),
      translate
    )
  },
  {
    type: 'inputNumberField',
    name: 'freeMonthlyCampaigns',
    label: translate('common.labels.freeMonthlyCampaigns'),
    rules: undefined,
    formatter: (value: any) => String(value ?? ''),
    parser: (value: any) => value
  },
  {
    type: 'inputNumberField',
    name: 'freeTokenDurationDays',
    label: translate('common.labels.freeTokenDurationDays'),
    rules: undefined,
    formatter: (value: any) => String(value ?? ''),
    parser: (value: any) => value
  },
  {
    type: 'checkBoxField',
    name: 'hasSubscription',
    label: translate('common.labels.hasSubscription'),
    rules: undefined
  }
];
